import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { styled, Typography, Stack, Button } from '@mui/material';
import { TPopupDefaultActions } from '../../../../../../../../shared/components/popup/services/popup.service.ts';
import { FormTextField } from '../../../../../../../../shared/components/form';
import { useFormContext } from 'react-hook-form';
import { IFormData } from '../clientDetails/clientDetails.popup.tsx';
import { bakery2bClientsState } from '../../../../../states/bakery2bClients.state.ts';

export class DeactivationPopup extends Popup<IDeactivationPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const {
        formState: { dirtyFields },
        getValues,
      } = useFormContext<IFormData>();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 410, minWidth: 300, width: '100%' },
          '& > div > div > div': { padding: 20 },
        }));
      }, []);

      return (
        <SWrapper sx={{ textAlign: 'center' }} stream={stream} popupTitle={t('common.confirm')}>
          <Typography
            variant='caption'
            color='textSecondary'
            sx={{
              fontSize: 15,
              fontWeight: 500,
            }}
          >
            {t('settings.deactivate_confirmation')}
          </Typography>
          <FormTextField
            required
            sx={{ mt: 3 }}
            label={t('common.reason')}
            width='100%'
            minRows={3}
            multiline
            name='whyDeactivated'
          />
          <Stack
            direction='row'
            sx={{
              justifyContent: 'flex-end',
              mt: 6,
            }}
          >
            <Button
              variant='contained'
              disabled={!dirtyFields.whyDeactivated}
              onClick={() => {
                bakery2bClientsState.pub.deactivateBakery2bClient(getValues().whyDeactivated || '');
                stream.emit('close');
              }}
              sx={{ minWidth: '125px' }}
              type='button'
            >
              {t('settings.deactivate_client')}
            </Button>
          </Stack>
        </SWrapper>
      );
    };
  }
}

export interface IDeactivationPopup {
  action: TPopupDefaultActions;
}
